<script type="text/jsx">
import MenuMixin from './menu-mixin'
import { PREFIX_CLASS } from '@/utils/constants'
const PREFIX_MENU_CLASS = `${PREFIX_CLASS}menu`
export default {
  name: 'TMenuItem',
  mixins: [MenuMixin],
  props: {
    name: {
      type: [String, Number],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      return [
        `${PREFIX_MENU_CLASS}__item`,
        {
          [`${PREFIX_MENU_CLASS}__item--checked`]: this.active,
          [`${PREFIX_MENU_CLASS}__item--disabled`]: this.isDisabled
        }
      ]
    },
    active() {
      return this.rootMenu.currentActiveName === this.name
    },
    isDisabled() {
      return this.parentMenu.disabled || this.disabled
    }
  },
  created() {
    if (this.parentMenu && this.parentMenu.$options.name === 'TSubmenu') {
      this.parentMenu.$_addItem(this)
    }
  },
  beforeDestroy() {
    // if (this.parentMenu && this.parentMenu.$options.name === 'TSubmenu') {
    //   this.parentMenu.$_removeItem(this)
    // }
  },
  methods: {
    $_handleClick(e) {
      e.stopPropagation()
      if (!this.isDisabled) {
        this.rootMenu.$_handleItemClick(this.name)
      }
    }
  },
  render(h) {
    return (
      <li class={this.classes}
        on-click={this.$_handleClick}>
        {this.$scopedSlots.default()}
      </li>
    )
  }
}
</script>



// WEBPACK FOOTER //
// src/module/menu/menu-item.vue